export const DELETE_WORKSPACE_MESSAGE =
  "Delete this workspace? Access stops now. You can restore it for 30 days. After that, the workspace and its data are permanently removed.";
